module.exports = __webpack_public_path__ + "static/media/data1.d7ea7d1c.png";